// extracted by mini-css-extract-plugin
export default {"between-block":"styles_between-block__YcUEd","between-block__content":"styles_between-block__content__psnXp"};